<template>
    <div class="border-design"></div>
  </template>
  
  <script>
  export default {
    name: 'BorderHeroBottom'
  }
  </script>
  
  <style scoped>
  .border-design {
    background-image: url('@/assets/images/borders/border-top.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    width: auto;
    height: 31px;
    margin-top: -1px;
  }
  
  /* Mobile version */
  @media screen and (max-width: 640px) {
    .border-design {
      background-image: url('@/assets/images/borders/border-top-640.png');
    }
  }
  
  @media screen and (max-width: 360px) {
    .border-design {
      background-image: url('@/assets/images/borders/border-top-520.png');
    }
  }
  </style>